import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const fetchExistingEmployeeList = createAsyncThunk('getPartialEmployeeData/fetchExistingEmployeeList',
  async ({page,SB,order}, { rejectWithValue }) => {
    try {
      // Use Math.max to ensure we never go below 0
      const sanitizedPage = Math.max(0, page - 1);
      // /api/v1/users/existing-employee?page=0&size=10&sortBy=firstName&direction=asc`,
      const url = `${api.existingEmployee}?page=${sanitizedPage}&size=20&sortBy=${SB}&direction=${order}`
      const response = await axiosPrivate.get(url);
      return response.data.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
    }
  })

const getExistingEmpListSlice = createSlice({
  name: 'existingEmployees',
  initialState: {
    existingEmployees: {},
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(fetchExistingEmployeeList.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(fetchExistingEmployeeList.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.existingEmployees = action.payload;
        })
      .addCase(fetchExistingEmployeeList.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        }
      )
  }
})

export default getExistingEmpListSlice.reducer;